import { useTranslation } from 'react-i18next';
import { usePinsStore } from '@/features/pins';

// US-09: открывает BulkImportDialog (компонент монтируется в MapPage).
// Кнопка живёт в header — рядом со ShortlistButton — чтобы вход в импорт
// был доступен из любой точки карты, а не только из DetailsPanel.
export function BulkImportButton() {
  const { t } = useTranslation();
  const open = usePinsStore((s) => s.openBulkImport);

  return (
    <button
      type="button"
      data-testid="bulk-import-button"
      onClick={open}
      className="inline-flex h-9 min-w-9 items-center justify-center gap-1 rounded-md border border-[color:var(--color-ink-100)] px-2 text-sm text-[color:var(--color-ink-700)] hover:bg-[color:var(--color-paper-2)] sm:px-2.5"
      title={t('pins.bulk.openTitle', { defaultValue: 'Import a shortlist of places' })}
      aria-label={t('pins.bulk.openTitle', { defaultValue: 'Import a shortlist of places' })}
    >
      <span aria-hidden="true">📌</span>
      <span className="hidden sm:inline">{t('pins.bulk.openLabel', { defaultValue: 'Import' })}</span>
    </button>
  );
}
